import { IVehicleDrivingEvent } from "../../services/serverEvents";
import { ActionsUnion, createAction } from "../definitions";
import { IIoxDataPayload, DeviceMovementActionTypes, IStateUpdate } from "./types";

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DeviceMovementActions = {
    setPubSubPayload: (payload: IVehicleDrivingEvent) => createAction(DeviceMovementActionTypes.SET_PUB_SUB_PAYLOAD, payload),
    setIoxDataPayload: (payload: IIoxDataPayload) => createAction(DeviceMovementActionTypes.SET_IOX_DATA_PAYLOAD, payload),
    setStateUpdate: (payload: IStateUpdate) => createAction(DeviceMovementActionTypes.SET_STATE_UPDATE, payload),
    setLastPayloadUpdated: () => createAction(DeviceMovementActionTypes.SET_LAST_PAYLOAD_UPDATED),
    clearStateUpdate: () => createAction(DeviceMovementActionTypes.CLEAR_STATE_UPDATE)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type DeviceMovementActions = ActionsUnion<typeof DeviceMovementActions>;